import React from "react";
import { Route, Switch } from "react-router-dom";
import { TheLayout } from "./containers";
import "./scss/style.scss";
import { AuthContext } from "./shared/context/auth-context";
import LoginPage from "./views/login";
import { ProtectedRoute } from "./ProtectedRoute";
import Auth from "./auth";
//import Page404 from "./views/pages/page404/Page404";

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

// Containers

// Pages

const App = () => {
  const { authenticated } = Auth();
  const details = authenticated;
  // console.log("authenticated", authenticated);
  return (
    <>
      <React.Suspense fallback={loading}>
        <AuthContext.Provider
          value={{
            isLoggedIn: !!details.jwt,
            userId: details.userId,
            username: details.username,
            token: details.jwt,
            role: details.role,
            district: details.district,
            isViewOnly: details.isViewOnly,
          }}
        >
          <Switch>
            <Route exact path="/login" component={LoginPage} />
            {details !== undefined && details !== null && (
              <ProtectedRoute path="*" component={TheLayout} />
            )}
          </Switch>
        </AuthContext.Provider>
      </React.Suspense>
    </>
  );
};

export default App;
